exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-6ad7ffd2]{font-size:1.75rem;line-height:1.75rem;color:#231f20;font-weight:500}@media (max-width:575px){h2[data-v-6ad7ffd2]{font-size:1.375rem;line-height:1.375rem}}svg[data-v-6ad7ffd2]{font-size:1.125rem}", ""]);

// exports
